import React, { useState } from 'react';
import { useStripe, useElements, PaymentElement, AddressElement } from '@stripe/react-stripe-js';
import Button from '../Button';
import { useNavigate } from 'react-router-dom';
import { LogErrors } from "../../utils/LogErrors";
import { useUserContext } from '../../context/userContext';

export default function Checkout({ amount, address, successURL = "/checkout/success", failureURL = "/checkout/error" }) {
  const stripe = useStripe();
  const elements = useElements();
  const navigate = useNavigate();
  const [tryingCharge, setTryingCharge] = useState(false);
  const { user, logout, updateTokens } = useUserContext();

  const handleSubmit = async (event) => {
    event.preventDefault();
  
    if (!stripe || !elements) return;

    setTryingCharge(true);
  
    const { error, paymentIntent } = await stripe.confirmPayment({
      elements,
      redirect: 'if_required'
    });
  
    if (error) {
      setTryingCharge(false);
      LogErrors(user, logout, updateTokens, "Payment failed: " + error);
      navigate(failureURL);
    } else if (paymentIntent) {
      setTryingCharge(false);
      // LogErrors(user, logout, updateTokens, "Payment succeeded! " + paymentIntent);
      navigate(`${successURL}/?paymentIntent=${paymentIntent.id}`);
    }
  };   

  return (
    <form onSubmit={handleSubmit}>
      {address && (
        <div>
          <h3 className="mb-2 text-lg font-semibold">Shipping Address</h3>
          <AddressElement
            options={{ mode: 'shipping' }}
            className="mb-6"
          />

          <h3 className="mb-2 text-lg font-semibold">Billing Address</h3>
          <AddressElement
            options={{ 
              mode: 'billing'
            }}
            className="mb-6"
          />
        </div>
      )}

      <PaymentElement className="mb-9" />
      <Button disabled={!stripe} submit className={`w-full`}>
          {tryingCharge ? (
            `Processing...`
          ) : `Pay £${amount}`}
      </Button>
    </form>
  );
};